@import '../../theme/global';

:host {
  @include set-font;
  color: $blue-600;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}
